import React from 'react';
import ComplementPersonConsult from './ComplementPersonConsult';

export default function PersonConsult() {
    return( 
        <span>
            <div className='reconect-banner'>
                <h5 className='reconect-text' style={{ color: "white" }}>CONSULTORIA PERSONALIZADA</h5>
            </div>
            <h5 className='reconect-text-connecting'>Conectando talentos, re-conectando propósitos</h5>
            <p style={{ textAlign: "center" }}>Consultoria personalizada para soluções sob medida, impulsionando resultados e aprimorando processos.</p>
        </span>
    );
}
